import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SubmitLineOfCreditPayment = gql`
  mutation SubmitManualPaymentForLineOfCredit(
    $idempotencyId: IdempotencyToken!
    $input: SubmitManualPaymentForLineOfCreditInput!
  ) {
    submitManualPaymentForLineOfCredit(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      ... on ManualPaymentError {
        __typename
        code
        message
        title
      }
      ... on ManualPaymentResponse {
        __typename
        outstandingBalance {
          ...money
        }
        responseMessage {
          captionText
          headlineText
          messageText
          noteText
        }
      }
    }
  }
  ${money}
`;

export default SubmitLineOfCreditPayment;
